"use strict";

var PredicatePattern = require("./predicate-pattern");

module.exports = new PredicatePattern(function () {
  return true;
});